import { render, staticRenderFns } from "./CourseSearchDropdown.vue?vue&type=template&id=f03634a4"
import script from "./CourseSearchDropdown.vue?vue&type=script&lang=js"
export * from "./CourseSearchDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports